import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';
import * as InfiniteScroll from 'react-infinite-scroller';

import { StoreState } from '../../reducers';
import Page from '../../containers/Page';
import { PageType } from '../../containers/Page/constants';
import { getProposals, reset, setProposalStatus } from '../../containers/ProposalStatsPage/actions';
import Toggle from '../Toggle';
import Table from '../../containers/ProposalStatsPage/Table';
import { Loader, TableWrapper } from './styles';
import { Api } from '../../typings/api';
import Utils from '../../utils';

interface ProposalStatsPageProps {
	proposalStatus: Api.ProposalStatus;
	page: number;
	totalPages: number;
	isResetNeeded: boolean;
	isLoading: boolean;
	dispatch: Dispatch<StoreState>;
}

const proposalStatusConfig = {
	[Api.ProposalStatus.SEEN]: {
		id: Api.ProposalStatus.SEEN,
		label: 'messages.status_read',
	},
	[Api.ProposalStatus.SENT]: {
		id: Api.ProposalStatus.SENT,
		label: 'messages.unread',
	},
};

const ProposalStatsPage = ({
	proposalStatus,
	page,
	totalPages,
	isResetNeeded,
	isLoading,
	dispatch,
}: ProposalStatsPageProps) => {
	const tableContainer = React.useRef<HTMLDivElement>(null);
	const hasMoreItems = !isLoading && page + 1 < totalPages;
	const isLoaderDisplayed = isLoading && page === 0;

	const loadMoreItems = () => {
		if (hasMoreItems) {
			dispatch(getProposals(page + 1));
		}
	};

	const handleProposalStatusChange = (proposalStatus: Api.ProposalStatus) => {
		dispatch(setProposalStatus(proposalStatus));
	};

	React.useEffect(() => {
		dispatch(getProposals());

		return () => {
			dispatch(reset());
		};
	}, []);

	React.useEffect(() => {
		if (isResetNeeded && tableContainer.current) {
			tableContainer.current.scrollTop = 0;
		}
	}, [isResetNeeded]);

	return (
		<Page
			pageType={PageType.ProposalStatsPage}
			title="messages.my_sent"
		>
			{isLoaderDisplayed &&
				<Loader>
					{Utils.getSvgIcon('iconset_loading')}
					<Translate value="messages.loading" />
				</Loader>
			}
			<Toggle
				items={Object.values(proposalStatusConfig)}
				activeId={proposalStatus}
				onItemClick={handleProposalStatusChange}
				width="110px"
			/>
			<TableWrapper ref={tableContainer}>
				<InfiniteScroll
					initialLoad={false}
					hasMore={hasMoreItems}
					loadMore={loadMoreItems}
					useWindow={false}
				>
					<Table />
				</InfiniteScroll>
			</TableWrapper>
		</Page>
	);
};

export default ProposalStatsPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/index.tsx